import { t } from '@glory/i18n';
import { Button, EmptyState } from '@glory/ui';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';

export interface RouterContext {
  readonly queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-6 text-text">
      <EmptyState
        title={<h1>{t('system.pageNotFound')}</h1>}
        action={
          <Button asChild variant="primary">
            <Link to="/">{t('system.toHome')}</Link>
          </Button>
        }
      />
    </main>
  );
}
